var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49987 8.47497L1.6082 5.58331C1.2832 5.25831 0.758203 5.25831 0.433203 5.58331C0.108203 5.90831 0.108203 6.43331 0.433203 6.75831L3.91654 10.2416C4.24154 10.5666 4.76654 10.5666 5.09154 10.2416L13.9082 1.42498C14.2332 1.09998 14.2332 0.574976 13.9082 0.249976C13.5832 -0.0750244 13.0582 -0.0750244 12.7332 0.249976L4.49987 8.47497Z",
    fill: "#03CE91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.45f9a00e36432c58fb459ef5bf3a80dd.svg";
export { ForwardRef as ReactComponent };